export const assetUrl = (path) => {
  const base = process.env.PUBLIC_URL || '';
  const cleaned = String(path || '').replace(/^\//, '');
  return `${base}/${cleaned}`;
};
